<template>
    <div v-cloak class="deny-reason-widget" :class="{ 'error': getIsValidField() }">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Reason for denial</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <h2 class="label-config" :class="{ 'has-errors': getIsValidField() }">The contact will receive an email
                    with the reason for denial.</h2>
                <div class="gray-container" :class="{ 'has-errors': getIsValidField() }">
                    <div class="custom-textarea">
                        <textarea id="text-area" v-model="denyReason" class="text-area" cols="30" rows="6"
                            placeholder="What is your reason for denying this request"></textarea>
                    </div>
                </div>
                <div class="error-message">Required</div>
            </div>
            <div class="widget-footer">
                <div class="action-container">
                    <app-button :disabled="isLoading" class="cancel-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                    <div class="rigth-buttons">
                        <app-button class="accept-btn" :loading="isLoading" @click="onClickSave">
                            Save and send
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template> 

<script>

import EventBus from '@/scripts/event-bus';
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
import { required } from 'vuelidate/lib/validators';
import { PartnerApplicationService } from '@/scripts/services/partner-application/partner-application-service';

export default {
    name: 'deny-reason-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
    },


    props: {
        widget: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            denyReason: '',
            isLoading: false,
        };
    },

    computed: {

    },

    validations() {
        return {
            denyReason: {
                required,
            }
        }
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        onClickSave() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return
            }

            if(this.widget.clientId){
                this.denyPartner();
            } else {
                this.denyStorefront();
            }
        },

        denyPartner(){
            PartnerApplicationService.deny({ clientId: this.widget.clientId, applicationId: this.widget.idRequest, reason: this.denyReason }).then(() => {
                    EventBus.$emit('partner-requests:update');
                    EventBus.$emit('deny-reason');
                    this.closeWidget();
                }).catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while sending your request.',
                        { error },
                    );
                }).finally(() => {
                    this.isLoading = false;
                })
        },

        denyStorefront(){
            StorefrontService.deny(this.widget.agencyId, {reason: this.denyReason})
                .then(() => {
                    EventBus.$emit('storefront:update');
                    this.closeWidget()
                }).catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while sending your request.',
                        { error },
                    );
                }).finally(() => {
                    this.isLoading = false;
                })
        },

        getIsValidField() {
            const isValid = this.$v.denyReason.$invalid && this.$v.denyReason.$dirty
            return isValid
        },
    },

}

</script>


<style>
.deny-reason-widget .gray-container {
    background: #fafafa;
    font: normal 16px/1em 'Roboto';
    width: 100%;
    border: 2px solid #cac6cb;
    padding: 7px 15px;
    border-radius: 20px;
    color: #382153;
}

.deny-reason-widget .error-message {
    font: normal normal normal 12px/14px Roboto;
    letter-spacing: 0px;
    color: #877D88;
    display: block;
    margin: 0.3em 0 1.25em 0;
}

.deny-reason-widget.error .error-message {
    color: #f30070;
}

.deny-reason-widget textarea:focus {
    outline: none;
}

.deny-reason-widget .gray-container.has-errors {
    border: 2px solid #F30070;
}

.deny-reason-widget .custom-textarea {
    display: flex;
    flex-direction: column;
    font-weight: 400;
    gap: 2px;
    font: normal 16px/1em 'Roboto';
    width: 100%;
}

.deny-reason-widget .text-area {
    resize: none;
    color: #382153;
}

.deny-reason-widget .text-area::placeholder {
    color: #CAC6CB;
}

.deny-reason-widget .inline-flex {
    display: inline-flex;
    gap: 10px;
    align-items: center;
}

.deny-reason-widget .cancel-btn {
    border: 1px solid #CAC6CB;
    border-radius: 20px;
    background: transparent;
    font: normal normal medium 14px/25px Roboto;
    letter-spacing: 0px;
    color: #382153;
    width: 127px !important;
    height: 40px !important;
}

.deny-reason-widget .cancel-btn:hover {
    background: #DCDCDC;
    border: 2px solid #CAC6CB;
}

.deny-reason-widget .rigth-buttons {
    display: flex;
    gap: 10px;
}

.deny-reason-widget .label-config {
    margin-top: 0;
}

.deny-reason-widget {
    font: normal normal normal 16px/20px Roboto;
    letter-spacing: 0px;
    color: #382153;
}

.deny-reason-widget h2 {
    font: normal bold 16px/24px Roboto;
    letter-spacing: 0px;
    margin-top: 25px;
}

.deny-reason-widget.error h2 {
    color: #f30070;
}

.deny-reason-widget a {
    font: normal normal normal 16px/11px Roboto;
    letter-spacing: 0px;
    color: #18AEFF;
}

.deny-reason-widget.widget .widget-header {
    background: rgb(80, 82, 254);
    background: linear-gradient(90deg, rgba(80, 82, 254, 1) 0%, rgba(75, 201, 254, 1) 100%);
}

.deny-reason-widget .action-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>